<template>
  <div id="aboutWork" ref="aboutWork" class="about-work">
    <app-close @close="closeInfo" class="portrait"></app-close>
    <div class="controls landscape">
      <a href="#" class="back-button" @click.prevent="changeCurrentWebsite(adjacentRoutes.prev)">previous</a>
      <a href="#" class="next-button" @click.prevent="changeCurrentWebsite(adjacentRoutes.next)">next</a>
      <app-close @close="closeInfo" class="landscape"></app-close>
    </div>
    <div class="content-wrap">
      <div class="media">
        <div class="controls near-media">
          <a href="#" class="back-button portrait" @click.prevent="changeCurrentWebsite(adjacentRoutes.prev)">previous</a>
          <a href="#" class="next-button portrait" @click.prevent="changeCurrentWebsite(adjacentRoutes.next)">next</a>
          <a
            :class="{ strikethrough: !currentWorkItem.url.url }"
            class="to-site-button"
            target="_blank"
            rel="noopener noreferrer"
            :href="currentWorkItem.url.url"
          >view on the web</a>
        </div>
        <div
          class="video-wrap"
          :class="currentWorkItem.videoModifier"
          :style="
            !currentWorkItem.video.url
              ? {
                  'background-image': 'url(' + currentWorkItem.image.url + ')',
                  'background-size': 'contain'
                }
              : ''
          "
        >
          <video
            v-if="currentWorkItem.video.url && !isMobileSafari"
            ref="video"
            :src="currentWorkItem.video.url"
            autoplay
            muted
            loop
          ></video>
          <video
            v-else-if="currentWorkItem.video.url"
            ref="video"
            :src="currentWorkItem.video.url"
            :poster="currentWorkItem.image.url"
            muted
            loop
            controls
            playsinline
          ></video>
        </div>
        <p v-if="!currentWorkItem.video.url" style="display:inline">(video unavailable)</p>
      </div>
      <div class="content">
        <h3>
          <template v-if="currentWorkItem.shortenedTitle">{{ currentWorkItem.shortenedTitle }}</template>
          <template v-else>{{ currentWorkItem.title }}</template>
        </h3>
        <div v-html="currentWorkItem.about" />
      </div>
    </div>
  </div>
</template>
<script>
import { isMobileSafari } from "../main";
import Close from "../components/svg/Close.vue";
import { eventBus } from "@/main";
export default {
  components: {
    appClose: Close,
  },
  methods: {
    changeCurrentWebsite(index) {
      this.$emit("changeCurrentWebsite", index);
      this.$nextTick(() => {
        this.$refs.aboutWork.scrollTo(0, 0);
        if (!this.currentWorkItem.video.url) return;
        this.$refs.video.play();
      });
    },
    closeInfo() {
      this.$emit("closeInfo");
    },
  },
  data() {
    return {
      workItems: this.$store.state.globals.workItems,
      vidBase: "https://d12dfyjdyr4tom.cloudfront.net/",
      isMobileSafari: isMobileSafari,
    };
  },
  computed: {
    adjacentRoutes() {
      let prevWorkItem, nextWorkItem;
      const workItems = this.workItems;
      if (this.currentIndex === workItems.length - 1) {
        prevWorkItem = workItems.length - 2;
        nextWorkItem = 0;
      } else if (this.currentIndex === 0) {
        prevWorkItem = workItems.length - 1;
        nextWorkItem = this.currentIndex + 1;
      } else if (this.currentIndex === workItems.length) {
        prevWorkItem = workItems.length - 1;
        nextWorkItem = 1;
      } else {
        prevWorkItem = this.currentIndex - 1;
        nextWorkItem = this.currentIndex + 1;
      }
      return {
        prev: prevWorkItem,
        next: nextWorkItem,
      };
    },
    currentWorkItem() {
      return this.$route.meta;
    },
    currentIndex() {
      return this.workItems.indexOf(this.$route.meta);
    },
  },
  mounted() {
    eventBus.$emit("aboutWindowOpened", true);
    if (!this.currentWorkItem.video.url) return;
    if (!isMobileSafari) {
      this.$refs.video.play();
    }
  },
};
</script>
